// "/" (HQ) と "/c/:companyId" (各社ポータル) の分岐。
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { useAuth } from "./lib/useAuth";
import { LoginPage } from "./pages/LoginPage";
import { HqLayout } from "./hq/HqLayout";
import { CreateMaterial } from "./hq/create/CreateMaterial";
import { History } from "./hq/history/History";
import { Companies } from "./hq/companies/Companies";
import { PortalLayout } from "./portal/PortalLayout";
import { PortalList } from "./portal/PortalList";
import { PortalDetail } from "./portal/PortalDetail";

function Loading() {
  return <div style={{ padding: 40, textAlign: "center", color: "var(--muted)" }}>読み込み中…</div>;
}

function RequireHQ({ children }: { children: React.ReactNode }) {
  const { user, claims, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (claims?.role !== "hq") return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function RequirePortalAccess({ children }: { children: React.ReactNode }) {
  const { user, claims, loading } = useAuth();
  const { companyId } = useParams();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  const ok = claims?.role === "hq" || claims?.companyId === companyId;
  if (!ok) return <div className="card" style={{ margin: 24 }}>この会社のポータルを閲覧する権限がありません。</div>;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route
        path="/"
        element={
          <RequireHQ>
            <HqLayout />
          </RequireHQ>
        }
      >
        <Route index element={<Navigate to="create" replace />} />
        <Route path="create" element={<CreateMaterial />} />
        <Route path="history" element={<History />} />
        <Route path="companies" element={<Companies />} />
      </Route>

      <Route
        path="/c/:companyId"
        element={
          <RequirePortalAccess>
            <PortalLayout />
          </RequirePortalAccess>
        }
      >
        <Route index element={<PortalList />} />
        <Route path="m/:materialId" element={<PortalDetail />} />
      </Route>

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
